import { ref } from 'vue'

export const capacitorOrigin = ref<string | null>(null)
